import React from 'react'
import '../../Assets/Css/Vision.css'
import banner  from '../../Assets/Images/banner.png'
const Vision = () => {
  return (
    <div className="vision-mission-container">
      <div className="vision-mission-item">
        <h3><span className="highlight">Our Vision</span></h3>
        <p>
          To create impactful cinematic experiences that resonate with audiences globally.
          Through innovative filmmaking and collaborative efforts, we aim to be at the
          forefront of the entertainment industry.
        </p>
      </div>
      <div className="vision-mission-item">
        <h3><span className="highlight">Our Mission</span></h3>
        <p>
          To produce films that inspire, entertain, and challenge the norms of traditional cinema.
          With an eye on new and emerging talent, we strive to push creative boundaries while
          respecting the traditions of Indian cinema.
        </p>
      </div>
    </div>
  )
}

export default Vision